import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postNewSupportRequest } from "../../services/supportRequests";

export interface SupportRequestsState {
  createSupportRequestSuccess: boolean;
  isLoadingCreateSupportRequest: boolean;
}

const name = "supportRequests";

export const supportRequestsSlice = createSlice({
  name,
  initialState: {
    createSupportRequestSuccess: false,
    isLoadingCreateSupportRequest: false,
  } as SupportRequestsState,
  reducers: {
    setCreateSupportRequestSuccess: (state, action) => {
      state.createSupportRequestSuccess = action.payload;
    },
    setIsLoadingCreateSupportRequest: (state, action) => {
      state.isLoadingCreateSupportRequest = action.payload;
    },
  },
});

const createSupportRequest = createAsyncThunk(
  `${name}/createSupportRequest`,
  async (formData: FormData, { dispatch }) => {
    try {
      dispatch(supportRequestsSlice.actions.setIsLoadingCreateSupportRequest(true));
      const { issue_key } = await postNewSupportRequest(formData);
      dispatch(
        supportRequestsSlice.actions.setCreateSupportRequestSuccess(!!issue_key),
      );
    } finally {
      dispatch(supportRequestsSlice.actions.setIsLoadingCreateSupportRequest(false));
    }
  },
);

const resetCreateSupportResult = createAsyncThunk(
  `${name}/resetCreateSupportResult`,
  async (anotherRequest: boolean, { dispatch }) => {
    dispatch(
      supportRequestsSlice.actions.setCreateSupportRequestSuccess(!anotherRequest),
    );
  },
);

export const thunks = {
  createSupportRequest,
  resetCreateSupportResult,
};

export const actions = {
  ...supportRequestsSlice.actions,
};
